export default __webpack_public_path__ + "static/ai-solutions-with-roadmap2-be566d633c01b4ab036e3224101c0750.webp";